class Departments {
  static names = {
    [Departments.getMenInternalName()]: 'Men',
    [Departments.getWomenInternalName()]: 'Women',
    [Departments.getKidsInternalName()]: 'Kids',
    [Departments.getBabyGirlsInternalName()]: 'Baby Girls',
    [Departments.getBabyBoysInternalName()]: 'Baby Boys',
    [Departments.getBabyUnisexInternalName()]: 'Kids',
    [Departments.getGirlsInternalName()]: 'Girls',
    [Departments.getBoysInternalName()]: 'Boys',
  };

  static namesCategoryNonDescriptiveSeo = {
    [Departments.getMenInternalName()]: 'Men',
    [Departments.getWomenInternalName()]: 'Women',
    [Departments.getKidsInternalName()]: 'Kids',
    [Departments.getBabyUnisexInternalName()]: 'Kids',
  };

  static possessiveNouns = {
    [Departments.getMenInternalName()]: "Men's",
    [Departments.getWomenInternalName()]: "Women's",
    [Departments.getKidsInternalName()]: "Kids'",
    [Departments.getBabyGirlsInternalName()]: "Baby Girls'",
    [Departments.getBabyBoysInternalName()]: "Baby Boys'",
    [Departments.getBabyUnisexInternalName()]: "Kids'",
    [Departments.getGirlsInternalName()]: "Girls'",
    [Departments.getBoysInternalName()]: "Boys'",
  };

  static oppositeDepartments = {
    [Departments.getWomenInternalName()]: Departments.getMenInternalName(),
    [Departments.getMenInternalName()]: Departments.getWomenInternalName(),
  };

  static getMenInternalName() {
    return 'men';
  }

  static getWomenInternalName() {
    return 'women';
  }

  static getUnisexInternalName() {
    return 'unisex';
  }

  static getKidsInternalName() {
    return 'kids';
  }

  static getKidsUnisexInternalName() {
    return 'kids-unisex';
  }

  static getBabyGirlsInternalName() {
    return 'baby-girls';
  }

  static getBabyBoysInternalName() {
    return 'baby-boys';
  }

  static getBabyUnisexInternalName() {
    return 'baby-unisex';
  }

  static getGirlsInternalName() {
    return 'girls';
  }

  static getBoysInternalName() {
    return 'boys';
  }

  static getKidsSingularNames() {
    return ['boy', 'girl', 'baby-boy', 'baby-girl'];
  }

  static getKidsDepartmentsInternalNames() {
    return [
      Departments.getKidsInternalName(),
      Departments.getKidsUnisexInternalName(),
      Departments.getBabyBoysInternalName(),
      Departments.getBabyGirlsInternalName(),
      Departments.getBabyUnisexInternalName(),
      Departments.getBoysInternalName(),
      Departments.getGirlsInternalName(),
      ...Departments.getKidsSingularNames(),
    ];
  }

  static getBabyKidsDepartmentsInternalNames() {
    return [
      Departments.getBabyGirlsInternalName(),
      Departments.getBabyBoysInternalName(),
      Departments.getBabyUnisexInternalName(),
    ];
  }

  static getJuniorKidsDepartmentsInternalNames() {
    return Departments.getKidsDepartmentsInternalNames().filter(
      department => !Departments.getBabyKidsDepartmentsInternalNames().includes(department),
    );
  }

  static getAdultsDepartmentsInternalNames() {
    return [Departments.getWomenInternalName(), Departments.getMenInternalName()];
  }

  static getInternalName(department) {
    if (Departments.getKidsDepartmentsInternalNames().includes(department)) {
      return Departments.getKidsInternalName();
    }

    return department;
  }

  static getWomenName() {
    return this.names[Departments.getWomenInternalName()];
  }

  static getMenName() {
    return this.names[Departments.getMenInternalName()];
  }

  static getKidsName() {
    return this.names[Departments.getKidsInternalName()];
  }

  static getBabyGirlsName() {
    return this.names[Departments.getBabyGirlsInternalName()];
  }

  static getBabyBoysName() {
    return this.names[Departments.getBabyBoysInternalName()];
  }

  static getGirlsName() {
    return this.names[Departments.getGirlsInternalName()];
  }

  static getBoysName() {
    return this.names[Departments.getBoysInternalName()];
  }

  static getWomenSynonyms() {
    const names = [Departments.getWomenName(), 'Woman'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getMenSynonyms() {
    const names = [Departments.getMenName(), 'Man'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getKidsSynonyms() {
    const names = [Departments.getKidsName(), 'Kid'];
    return [...names, ...names.map(el => el.toLowerCase())];
  }

  static getAllowedDepartmentNames() {
    return [...Departments.getWomenSynonyms(), ...Departments.getMenSynonyms(), ...Departments.getKidsSynonyms()];
  }

  static getOppositeDepartment(department) {
    return this.oppositeDepartments[department];
  }

  static getName(department) {
    return this.names[department];
  }

  static getNameAsPossessiveNoun(department) {
    return this.possessiveNouns[department];
  }
}

export default Departments;
